module.exports = __webpack_public_path__ + "static/img/index-sys.b60f675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appimg/index/pic/index-sys.jpg
// module id = Ge/O
// module chunks = 11